/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Cat_LayoutInputs */

const cs_builder_cat_layout = /** @type {(inputs: Builder_Cat_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozložení`)
};

const en_builder_cat_layout = /** @type {(inputs: Builder_Cat_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout`)
};

/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Builder_Cat_LayoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_cat_layout = /** @type {((inputs?: Builder_Cat_LayoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Cat_LayoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_cat_layout(inputs)
	return cs_builder_cat_layout(inputs)
});